<template>
    <nav class="navbar navbar-toggleable-sm sticky-top landing-page-nav">
        <div class="container">
            <a :href="homeLink" class="navbar-brand" v-if="carrierDetails">
                <img :src="`https://wefix-files.s3.eu-west-2.amazonaws.com/images/logos/${carrierDetails.name}/${navbarLogoPath}.svg`" class="logo" :alt="`${carrierDetails.formattedName}`">
            </a>
            <ul class="navbar-nav">
                <li class="nav-item active">
                    <router-link v-if="countryCodeSetting !== 'AU' && countryCodeSetting !== 'DE'" :to="{name: 'Faqs'}" class="nav-link">{{$t('bp.help')}}</router-link>
                    <a v-if="countryCodeSetting === 'AU'" href="https://likewizerepair.com.au/help" class="nav-link">{{$t('bp.help')}}</a>
                    <a v-if="countryCodeSetting === 'DE'" href="https://samsung-repair.de/de/faqs" class="nav-link">{{$t('bp.help')}}</a>
                </li>
                <li class="nav-item active">
                    <router-link v-if="countryCodeSetting !== 'AU' && countryCodeSetting !== 'DE'" :to="{name: 'Contact'}" class="nav-link">{{$t('bp.contact')}} <template v-if="partnerEnvironment === 'ee'">Likewize</template></router-link>
                    <a v-if="countryCodeSetting === 'AU'" href="https://likewizerepair.com.au/contact-us" class="nav-link">{{$t('bp.contact')}}</a>
                    <a v-if="countryCodeSetting === 'DE'" href="https://samsung-repair.de/de/contact" class="nav-link">{{$t('bp.contact')}}</a>
                </li>
                <li class="nav-item active">
                    <router-link :to="{name: 'manageBookingIndex'}" class="nav-link">{{$t('bp.manageBooking')}}</router-link>
                </li>
            </ul>
            <router-link :to="{name: 'basket'}" class="basket-toggle" :class="{'invisible': !deviceCount || isCompletePage}">
                <span class="badge basket-count">{{ deviceCount }}</span>
                <icon-shopping-cart size="xl"></icon-shopping-cart>
            </router-link>
        </div>
    </nav>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "LandingPageNavbar",

    computed: {
        ...mapGetters([
            'booking',
            'bookingPostcode',
            'carrier',
            'carrierDetails',
            'countryCodeSetting',
            'devices',
            'hasDevices',
            'bookingPostcodeHasBeenSet',
			'partnerEnvironment'
        ]),

        /** Total number of devices in the cart */
        deviceCount() {
            if (!this.devices) return 0;
            return Object.keys(this.devices).length;
        },

        /** Where the logo links to */
        homeLink() {
            switch (this.carrier) {
                case 'wefix': {
                    return 'https://wefix.co.uk';
                }
                case 'samsungrepair': {
                    return 'https://samsungrepair.com';
                }
                case 'samsungrepair-de': {
                    return 'https://samsung-repair.de';
                }
                case 'likewize-au': {
                    return 'https://likewizerepair.com.au';
                }
                case 'likewize-us': {
                    return 'https://likewizerepair.com';
                }
                // case 'vodafone': {
                //     return 'https://www.vodafone.co.uk/'
                // }
                default: {
                    return "/"
                }
            }
        },

        /** Complete Page */
        isCompletePage() {
            return (this.$route.meta.pageSection === 'complete');
        },

        /** Logo path **/
        navbarLogoPath() {
            if (this.carrierDetails.landingPageLogoPath) {
                return this.carrierDetails.landingPageLogoPath;
            }

            return this.carrierDetails.logoPath;
        }
    }
}
</script>

<style scoped>

</style>